<template>
    <div class="row" :class="{'hm-calendar-container': weekOptions.includes(searchType) || monthOptions.includes(searchType)}">
        <!-- Task Summary -->
        <div v-if="switchToView == 'new_view'" class="col-md-12">
            <handyman-summary 
                :location="'taskDashboard'"
                @switch-to-view="switchToView = $event"
            />
        </div>
        <div v-else class="col-md-12">
            <div class="card border-0">
                <div class="card-body p-0">
                    <div class="card-header fw-bold text-black d-flex justify-content-between p-3">
                        <div class="d-flex align-items-center gap-2 fs-4">
                            <template v-if="daysOptions.includes(searchType)">
                                {{ formattedDate(selectedDate, 'DD MMM YYYY').toUpperCase() }}
                            </template>
                            <template v-else-if="weekOptions.includes(searchType)">
                                {{ formattedDate(startOfWeek, 'DD MMM YYYY').toUpperCase() }} - {{ formattedDate(endOfWeek, 'DD MMM YYYY').toUpperCase() }}
                            </template>
                            <template v-else-if="monthOptions.includes(searchType)">
                                {{ formattedDate(currentMonth, 'MMM YYYY').toUpperCase() }}
                            </template>

                            <!-- <i @click="getPreviousData" class="bi bi-chevron-left cursor-pointer fs-5"></i>
                            <i @click="getNextData" class="bi bi-chevron-right cursor-pointer fs-5"></i> -->
                            <span class="cursor-pointer" title="Previous" @click="getPreviousData">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-left-icon lucide-square-arrow-left"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="m12 8-4 4 4 4"/><path d="M16 12H8"/></svg>
                            </span>
                            <span class="cursor-pointer" title="Next" @click="getNextData">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-right-icon lucide-square-arrow-right"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M8 12h8"/><path d="m12 16 4-4-4-4"/></svg>
                            </span>
                            <button 
                                type="button"
                                class="btn btn-sm btn-outline-theme ms-2"
                                @click="switchToView = 'new_view'"
                            >Switch to New View</button>

                            <!-- <button
                                type="button"
                                class="btn btn-sm btn-outline-theme ms-2"
                                v-text="displayMap ? 'View Calendar' : 'View Map'"
                                @click="displayMap= !displayMap"
                            ></button> -->
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <!--<div>
                                <Select2
                                    v-model="displayType"
                                    :options="[{id: 'day', text: 'Day'}, {id: 'week', text: 'Week'}, {id: 'month', text: 'Month'}]"
                                    :settings="{ minimumResultsForSearch: 'Infinity'}"
                                    class="task-display-type"
                                />
                            </div>
                            <div class="btn-group btn-group-sm border rounded-1" role="group">
                                <button class="btn btn-light" @click="getPreviousData"><i class="bi bi-chevron-left"></i></button>
                                <button class="btn btn-light" @click="setTodayDateData">Today</button>
                                <button class="btn btn-light" @click="getNextData"><i class="bi bi-chevron-right"></i></button>
                            </div>-->
                            <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Search Task"
                                v-model="searchTerm"
                            >
                            
                            <div class="hm-db--date-filter">
                                <Select2
                                    v-model="searchType"
                                    :options="[{id: 'this_week', text: 'This Week'}, {id: 'next_week', text: 'Next Week'}, {id: 'this_month', text: 'This Month'}]"
                                    :settings="{ minimumResultsForSearch: 'Infinity', placeholder: 'Filter Order' }"
                                />
                            </div>
                            <button
                                type="button"
                                class="btn btn-sm"
                                :class="[searchType === 'today' ? 'btn-theme' : 'btn-outline-theme']"
                                @click="searchType='today'"
                            >Today</button>
                            <button
                                type="button"
                                class="btn btn-sm"
                                :class="[searchType === 'tomorrow' ? 'btn-theme' : 'btn-outline-theme']"
                                @click="searchType='tomorrow'"
                            >Tomorrow</button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-danger"
                                @click="searchType='today'"
                            >Reset</button>

                            <button type="button" class="btn btn-sm btn-outline-success" title="Export to CSV" @click="exportToCSV">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" x2="12" y1="15" y2="3"/></svg>
                            </button>
                            <button type="button" class="btn btn-sm btn-theme" @click="displayMap = !displayMap" title="Display Map">
                                <svg v-if="displayMap" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-off-icon lucide-map-pin-off"><path d="M12.75 7.09a3 3 0 0 1 2.16 2.16"/><path d="M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568"/><path d="m2 2 20 20"/><path d="M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533"/><path d="M9.13 9.13a3 3 0 0 0 3.74 3.74"/></svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-plus-icon lucide-map-pin-plus"><path d="M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738"/><circle cx="12" cy="10" r="3"/><path d="M16 18h6"/><path d="M19 15v6"/></svg>
                            </button>
                        </div>
                    </div>
                </div>
                <template v-if="displayMap">
                    <google-map :orders="taskLists"></google-map>
                </template>
                <template v-else>
                    <template v-if="['today', 'tomorrow', 'yesterday', 'custom_day'].includes(searchType)">
                        <div class="card-body p-0 border-0" ref="tableContainer">
                            <div class="overflow-auto handyman-task-table-container">
                                <table class="table table-bordered align-middle handyman-task-table hm-table-fixed">
                                    <thead :class="fixedTaskHeadClass" class="">
                                        <tr class="">
                                            <th class="task-hour-column"></th>
                                            <th :colspan="Object.keys(handymans).length" class="text-center task-head-date">
                                                <h4 class="p-0 m-0">
                                                    <!--<template v-if="displayType === 'day'">
                                                        {{ formattedDate(selectedDate, 'DD MMM YYYY').toUpperCase() }}
                                                    </template>
                                                    <template v-else-if="displayType === 'week'">
                                                        {{ formattedDate(startOfWeek, 'DD MMM YYYY').toUpperCase() }} - {{ formattedDate(endOfWeek, 'DD MMM YYYY').toUpperCase() }}
                                                    </template>
                                                    <template v-else-if="displayType === 'month'">
                                                        {{ formattedDate(currentMonth, 'MMM YYYY').toUpperCase() }}
                                                    </template>-->
                                                    {{ formattedDate(selectedDate, 'DD MMM YYYY').toUpperCase() }}
                                                </h4>
                                            </th>
                                        </tr>
                                        <tr>
                                            <th class="task-hour-column"></th>
                                            <th v-for="(handyman, index) in handymans" :key="index" class="text-no-wrap align-middle bg-theme">
                                                <div class="d-flex justify-content-between task-handyman-head rounded">
                                                    <div class="align-middle">{{ handyman.full_name }}</div>
                                                    <div class="task-count rounded">{{ (Object.keys(handyman.tasks).length > 0) ? handyman.tasks.length : 0 }}</div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(time, timeIndex) in orderTimes" :key="timeIndex" ref="tableRow">
                                            <td class="justify-content-center text-center task-hour-column">{{ time.label }}</td>
                                            <template v-for="(handyman, hmIndex) in handymans">
                                                <td
                                                    v-if="
                                                        (task_list = handyman.tasks.filter(e => {
                                                            return e.hour < time.hour && e.hour + e.assigned_order_duration > time.hour;
                                                        })).length === 0"
                                                    :key="hmIndex"
                                                    class="justify-content-center"
                                                    :data-handyman="handyman.id"
                                                    :rowspan="handyman.tasks.length > 0 && (task_list = handyman.tasks.filter(e => {
                                                        return e.hour == time.hour;
                                                    })).length > 0 ? task_list[0].assigned_order_duration : 1"
                                                >
                                                    <draggable
                                                        class="order-list-group hm-day-container w-100 h-100"
                                                        v-model="handyman.tasks"
                                                        v-bind="dragOptions"
                                                        group="people"
                                                        :item-key="time.hour"
                                                        :component-data="{target_hour: time.hour, target_handyman: handyman.id, target_class: handyman.class, schedules: handyman.handyman_schedules}"
                                                        @start="startDrag"
                                                        :move="onMove"
                                                        @end="endDrag"
                                                        @change="onChangeItem"
                                                    >
                                                        <template #item="{element}">
                                                            <div
                                                                v-if="handyman.id === element.handyman_id && element.hour == time.hour"
                                                                class="hm-service-card h-100 p-2 mb-1 pt-1 rounded order-list-group-item hm-fs-11"
                                                                :class="handyman.class"
                                                                @contextmenu.prevent.stop="taskItemClick($event, element)"
                                                            >
                                                                <div class="d-flex justify-content-between pt-1 pb-0">
                                                                    <label class="order-client-name">{{ truncateString(element.customer_full_name, 18) }}</label>
                                                                    <label v-if="element.postal_code != ''" class="order-client-postcode text-nowrap rounded text-end">{{ element.postal_code }}</label>
                                                                </div>
                                                                <div class="d-flex justify-content-between pt-1 pb-1">{{ truncateString(element.full_address, 25) }}</div>
                                                                <div v-if="element.acp_full_name != ''" class="d-flex justify-content-between pb-0">
                                                                    <label><small>{{ truncateString(element.acp_full_name, 20) }}</small></label>
                                                                </div>
                                                                <label class="badge bg-theme p-1 text-wrap">
                                                                    {{ 
                                                                        element?.order_handymans?.map(order_handymans => formatName(order_handymans.handyman?.name)).join(', ')
                                                                    }}
                                                                </label>
                                                            </div>

                                                        </template>
                                                    </draggable>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>
                    <template v-if="['this_week', 'next_week', 'custom_week', 'this_month', 'custom_month'].includes(searchType)">
                    <div class="card-body p-0 border-0 not-date">
                        <!--<div
                            class="hm-due-date-table"
                            :class="{ 'overflow-auto': monthOptions.includes(searchType) }"
                            :style="{ height: screenHeight + 'px' }"
                        >-->
                        <div class="hm-due-date-table">
                            <!-- Display monthly data -->
                            <table class="table table-bordered mb-0 hm-table-fixed">
                                <thead class="due-date-table-head">
                                    <tr>
                                        <td
                                            class="text-center"
                                            v-for="(week, index) in weekDays"
                                            :key="index"
                                        >
                                            {{ week.day }}
                                            <div v-if="weekOptions.includes(searchType)" class="fs-6">
                                                {{ week.day_of_month }}/{{ week.year }}
                                            </div>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="weekOptions.includes(searchType)">
                                        <td
                                            v-for="(week, index) in weekDays"
                                            :key="index"
                                            :class="{'disabled-day': !isScheduleAvailable(week.date) }"
                                        >
                                            <div class="task-dashboard-container hm-day-container mx-auto align-middle order-item-container">
                                                <draggable
                                                    :disabled="false"
                                                    v-model="taskLists"
                                                    v-bind="dragOptions"
                                                    group="people"
                                                    :item-key="'calender'"
                                                    :component-data="{
                                                        day_of_month: week.day_of_month,
                                                        date: week.date
                                                    }"
                                                    style="min-height: 100px;"
                                                    @start="startDrag"
                                                    :move="onMove"
                                                    @end="endDrag"
                                                    @change="onChangeItem"
                                                >
                                                    <template #item="{ element }">
                                                        <div
                                                            v-if="element.day_of_month == week.day_of_month"
                                                            class="hm-service-card h-100 p-2 mb-1 pt-1 rounded order-list-group-item hm-fs-11"
                                                            :class="getRandomClass()"
                                                            @contextmenu.prevent.stop="taskItemClick($event,element)"
                                                        >
                                                            <div class="d-flex justify-content-between pt-1 pb-0">
                                                                <label class="order-client-name">{{ truncateString(element.customer_full_name, 18) }}</label>
                                                                <label v-if="element.postal_code != ''" class="order-client-postcode text-nowrap rounded text-end">{{ element.postal_code }}</label>
                                                            </div>
                                                            <div class="d-flex justify-content-between pt-1 pb-1">{{ truncateString(element.full_address, 25) }}</div>
                                                            <div v-if="element.acp_full_name != ''" class="d-flex justify-content-between pb-0">
                                                                <label><small>{{ truncateString(element.acp_full_name, 20) }}</small></label>
                                                            </div>
                                                            <label class="badge bg-theme p-1 text-wrap">
                                                                {{ 
                                                                    element?.order_handymans?.map(order_handymans => formatName(order_handymans.handyman?.name)).join(', ')
                                                                }}
                                                            </label>
                                                        </div>
                                                    </template>
                                                </draggable>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr
                                        v-else
                                        v-for="(week, index) in calendar"
                                        :key="index"
                                    >
                                        <td
                                            v-for="item in week"
                                            :key="item.day"
                                            class=""
                                            :class="{ 'text-muted': item.day === '', 'disabled-day': !isScheduleAvailable(item.date) }"
                                        >
                                            <div class="task-dashboard-container hm-day-container">
                                                <div class="">{{ item.day }}</div>
                                                <!-- Iterate the due date services and display the service name -->
                                                <div class="mx-auto">
                                                    <draggable
                                                        class="order-list-group"
                                                        v-model="taskLists"
                                                        v-bind="dragOptions"
                                                        group="people"
                                                        :item-key="'calender'"
                                                        :component-data="{
                                                            day_of_month: item.day,
                                                            date: item.date
                                                        }"
                                                        @start="startDrag"
                                                        :move="onMove"
                                                        @end="endDrag"
                                                        @change="onChangeItem"
                                                    >
                                                        <template #item="{ element }">
                                                            <div v-if="element.day_of_month == item.day"
                                                                class="hm-service-card task-dashboard-container p-2 mb-1 rounded order-list-group-item"
                                                                :class="getRandomClass()"
                                                                @contextmenu.prevent.stop="taskItemClick($event,element)"
                                                            >
                                                                <div class="d-flex justify-content-between pt-1 pb-0">
                                                                    <label class="order-client-name">{{ truncateString(element.customer_full_name, 18) }}</label>
                                                                    <label v-if="element.postal_code != ''" class="order-client-postcode text-nowrap px-1 rounded text-end">{{ element.postal_code }}</label>
                                                                </div>
                                                                <div class="d-flex justify-content-between pt-1 pb-1">{{ truncateString(element.full_address, 25) }}</div>
                                                                <div v-if="element.acp_full_name != ''" class="d-flex justify-content-between pb-0">
                                                                    <label><small>{{ truncateString(element.acp_full_name, 20) }}</small></label>
                                                                </div>
                                                                <label class="badge bg-theme p-1 text-wrap">
                                                                    {{ 
                                                                        element?.order_handymans?.map(order_handymans => formatName(order_handymans.handyman?.name)).join(', ')
                                                                    }}
                                                                </label>
                                                            </div>
                                                        </template>
                                                    </draggable>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
                </template>
            </div>
        </div>
    </div>
    <!-- right click context -->
    <vue-simple-context-menu
        element-id="myFirstMenu"
        :options="taskOptions"
        ref="taskItemContext"
        @option-clicked="taskItemMenuAction"
    >
    </vue-simple-context-menu>

    <!-- Add Attachment Modal -->
        <div
            class="modal fade"
            id="addAttachmentModal"
            tabindex="-1"
            aria-labelledby="addAttachmentModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addAttachmentModalLabel">
                            Add Attachment
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3">
                            <label for="reasonInput" class="form-label"
                                >Comment for Attachment</label
                            >
                            <textarea
                                class="form-control"
                                id="reasonInput"
                                v-model="updateOrderData.comment"
                            ></textarea>
                        </div>
                        <div class="col-md-12 mb-3">
                            <label for="description" class="form-label"
                                >Attachment</label
                            >
                            <div class="input-group mb-3">
                                <input
                                    type="file"
                                    class="form-control"
                                    multiple
                                    @change="onFileChange"
                                />
                            </div>

                            <!-- Display image preview -->
                            <img
                                v-for="previewImage in previewOrderImages"
                                :src="previewImage"
                                class="img-thumbnail me-2 mb-2"
                                style="{max-height: 150px;max-width: 150px;}"
                                :key="previewImage"
                            />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            @click="cancleAddAttachment"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="addAttachment"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import draggable from 'vuedraggable'
import moment from 'moment';
import Select2 from 'vue3-select2-component';
import VueSimpleContextMenu from "vue-simple-context-menu";
import "vue-simple-context-menu/dist/vue-simple-context-menu.css";
import GoogleMap from "./GoogleMap";
import { appMixin } from '../mixin/appMixin';

import HandymanSummary from './Dashboard/HandymanSummary';

export default {
    name: "TaskDashboard",
    components: {
        draggable,
        Select2,
        VueSimpleContextMenu,
        GoogleMap,
        HandymanSummary
    },
    mixins: [appMixin],
    data() {
        return {
            loading: false,
            selectedDate: moment().format('YYYY-MM-DD'),
            currentTask: {},
            previewOrderImages: [],
            weekDays: [],
            calendar: [],
            taskOptions: [
                { name: "View Order", job: "order-view" },
                { name: "Add Attachment", job: "add-attachment" },
            ],
            updateOrderData:{
                files: []
            },
            // orderTimes1: [
            //     // {hour: '1', label: '1am'},
            //     // {hour: '2', label: '2am'},
            //     // {hour: '3', label: '3am'},
            //     // {hour: '4', label: '4am'},
            //     // {hour: '5', label: '5am'},
            //     // {hour: '6', label: '6am'},
            //     {hour: '7', label: '7am'},
            //     {hour: '8', label: '8am'},
            //     {hour: '9', label: '9am'},
            //     {hour: '10', label: '10am'},
            //     {hour: '11', label: '11am'},
            //     {hour: '12', label: '12pm'},
            //     {hour: '13', label: '1pm'},
            //     {hour: '14', label: '2pm'},
            //     {hour: '15', label: '3pm'},
            //     {hour: '16', label: '4pm'},
            //     {hour: '17', label: '5pm'},
            //     {hour: '18', label: '6pm'},
            //     {hour: '19', label: '7pm'},
            //     {hour: '20', label: '8pm'},
            //     // {hour: '21', label: '9pm'},
            //     // {hour: '22', label: '10pm'},
            //     // {hour: '23', label: '11pm'},
            //     // {hour: '00', label: '12am'},
            // ],
            handymans: [],
            selectedHour: '',
            moveToHour: '',
            taskItemClasses: [
                'task-bg-green',
                'task-bg-light-green',
                'task-bg-purple',
                'task-bg-orange',
                'task-bg-warning',
                'task-bg-blue',
                'task-bg-default',
                'task-bg-pink'
            ],
            fixedTaskHeadClass: '',
            targetHour: '',
            targetHandyman: '',
            targetDate: '',
            taskLists:[],
            targetClass: '',
            displayType: 'day', // month, week, day
            startOfWeek: '',
            endOfWeek: '',
            currentWeek: '',
            currentMonth: '',
            searchType: 'today',
            searchTerm: '',
            schedules: [],
            daysOptions: ['today', 'tomorrow', 'yesterday', 'custom_day'],
            weekOptions: ['this_week', 'next_week', 'custom_week'],
            monthOptions: ['this_month', 'next_month' , 'custom_month'],
            displayMap: false,
            switchToView: 'new_view', // new_view, old_view
        }
    },
    created() {
        // Prepare current week
        this.startOfWeek = moment().startOf('isoWeek').format('YYYY-MM-DD');
        this.endOfWeek = moment().endOf('isoWeek').format('YYYY-MM-DD');
        this.currentWeek = this.startOfWeek + ' - ' + this.endOfWeek;

        // Prepare current month
        this.currentMonth = moment();

        this.getTasks();
    },
    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        orderTimes() {
            const start = this.momentObj(this.settings.hm_working_hours_start, 'HH:mm'); // 07:00
            const end = this.momentObj(this.settings.hm_working_hours_end, 'HH:mm').subtract(1, 'hour'); // 17:00
            const times = [];
            let currentTime = start.clone();
            while (currentTime <= end) {
                times.push({
                    hour: currentTime.format('H'),
                    label: currentTime.format('hA'),
                });
                currentTime.add(1, 'hour');
            }
            return times;
        }
    },
    mounted() {
        this.preparedWeekDays();
        this.generateCalendar();
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        preparedWeekDays() {
            // Prepare week days
            const startDate = this.startOfWeek; // Start of the current week
            const endDate = this.endOfWeek; // End of the current week

            const currentDay = moment(startDate);
            const weekDays = [];

            while (currentDay.isSameOrBefore(endDate)) {
                weekDays.push({
                    year: currentDay.format("YY"),
                    date: currentDay.format("YYYY-MM-DD"),
                    day: currentDay.format("ddd"),
                    day_of_month: currentDay.format("DD"),
                });
                currentDay.add(1, "day");
            }

            this.weekDays = weekDays;
        },
        addAttachment() {
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
            axios
                .post(
                    "/admin/orders/update-order",
                    {
                        action_type: 'attachment_addded',
                        order_id: this.updateOrderData.id,
                        comment: this.updateOrderData.comment,
                        files: this.updateOrderData.files,
                    },
                    config
                )
                .then((response) => {
                    this.cancleAddAttachment();

                    this.$notification(
                        response.data.status,
                        response.data.message
                    );
                });
        },
        cancleAddAttachment() {
            this.updateOrderData.files = [];
            this.updateOrderData.comment = "";
            $("#addAttachmentModal").modal("hide");
        },
        onFileChange(event) {
                for (let file of event.target.files) {
                    try {
                        let reader = new FileReader();

                        // Display the image preview
                        reader.onload = (e) => {
                            this.previewOrderImages.push(e.target.result);
                        };
                        reader.readAsDataURL(file); // Not sure if this will work in this context.
                        this.updateOrderData.files.push(file);
                    } catch {}
                }
            },
        taskItemMenuAction(event) {
            if (event.option.job === "order-view") {
                // Open in the same tab
                window.location.href = "/admin/orders/" + event.item.order_number;
                return;
                //window.open("/admin/orders/" + event.item.order_number);
            } else if (event.option.job === "add-attachment") {
                this.updateOrderData.id = event.item.id;
                this.updateOrderData.status = event.item.status
                this.updateOrderData.files = [];
                this.updateOrderData.comment = "";
                $("#addAttachmentModal").modal("show");
            }
        },
        taskItemClick(event, item) {
            this.$refs.taskItemContext.showMenu(event, item);
        },
        getTasks() {
            let self = this;

            let startDate = '';
            let endDate = '';

            if (this.searchType === 'today') {
                startDate = moment().format('YYYY-MM-DD');
                endDate = moment().format('YYYY-MM-DD');
            }
            else if(this.searchType === 'tomorrow') {
                startDate = moment().add(1, 'days').format('YYYY-MM-DD');
                endDate = moment().add(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'yesterday') {
                startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_day') {
                startDate = moment(this.selectedDate).format('YYYY-MM-DD');
                endDate = moment(this.selectedDate).format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_week') {
                startDate = moment().startOf('week').format('YYYY-MM-DD');
                endDate = moment().endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'next_week') {
                startDate = moment().add(1, 'week').startOf('week').format('YYYY-MM-DD');
                endDate = moment().add(1, 'week').endOf('week').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_week') {
                startDate = moment(this.startOfWeek).format('YYYY-MM-DD');
                endDate = moment(this.endOfWeek).format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_month') {
                startDate = moment().startOf('month').format('YYYY-MM-DD');
                endDate = moment().endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'last_month') {
                startDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                endDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'custom_month') {
                startDate = moment(this.currentMonth).startOf('month').format('YYYY-MM-DD');
                endDate = moment(this.currentMonth).endOf('month').format('YYYY-MM-DD');
            }
            else if(this.searchType === 'this_year') {
                startDate = moment().startOf('year').format('YYYY-MM-DD');
                endDate = moment().endOf('year').format('YYYY-MM-DD');
            }

            axios.post('/admin/tasks/list', {
                display_type: this.displayType,
                week_start: this.startOfWeek,
                week_end: this.endOfWeek,
                current_month: this.currentMonth,
                current_date: this.selectedDate,
                search_type: this.searchType,
                start_date: startDate,
                end_date: endDate,
                search_term: this.searchTerm
            })
                .then(response => {
                    this.handymans = response.data.handymanman_with_tasks;
                    this.schedules = response.data.schedules;

                    Object.keys(this.handymans).forEach((key) => {
                        self.handymans[key]['class'] = self.getRandomClass();
                    });
                    const tasks = [];
                    response.data.handymanman_with_tasks.forEach((handyman) => {
                        handyman.tasks.forEach((task) => {
                            tasks.push(task);
                        })
                    });
                    this.taskLists = [...new Map(tasks.map(item => [item['id'], item])).values()];

                    // Scroll to the 9am row
                    //this.scrollToRow(1);
                })
        },
        startDrag() {
            this.drag = true;
        },
        endDrag(event) {
            this.drag = false;
        },
        onMove({relatedContext, draggedContext}) {

            let relatedComponent    = relatedContext.component;
            let componentData       = relatedComponent.componentData;
            let draggedElement      = draggedContext.element;
            let currentHandyman     = draggedElement.handyman_id;

            // Get the handyman schedule
            let handymanSchedules = typeof this.schedules[currentHandyman] !== 'undefined' ? this.schedules[currentHandyman] : [];

            // Check if provider_id and handyman_id are sme then get all the schedules
            // This case is handyman not assigned to this task
            if(draggedElement.provider_id == draggedElement.handyman_id) {
                Object.keys(this.schedules).forEach((handymanId) => {
                    this.schedules[handymanId].forEach((schedule) => {
                        handymanSchedules.push(schedule);
                    });
                });
            }

            // Check for the today and tomorrow
            if (['today', 'tomorrow'].includes(this.searchType)) {
                // Check if target hour is within any schedule
                const isTargetHourAvailable = componentData.schedules.some(schedule =>
                    componentData.target_hour >= schedule.start_hour && componentData.target_hour <= schedule.end_hour
                );

                if (!isTargetHourAvailable) {
                    return false;
                }
            }
            else if(['this_week', 'next_week', 'custom_week','last_month', 'this_month', 'next_month', 'custom_month'].includes(this.searchType)) {
                let dayOfMonth = componentData.day_of_month;
                let date = componentData.date;

                // Check if target date is less than current date then return false
                if(date < moment().format('YYYY-MM-DD')) {
                    //return false;
                }

                // Check if date is within any handyman schedule
                const isDateAvailable = handymanSchedules.some(schedule =>
                    date === schedule.schedule_date
                );

                if (!isDateAvailable) {
                    return false;
                }

                // Set the target date
                this.targetDate = date;
            }

            this.targetHour     = componentData.target_hour;
            this.targetHandyman = componentData.target_handyman;
            this.targetClass    = componentData.target_class;
        },
        onChangeItem(event) {
            let self = this;
            if(event.added) {
                //console.log(event.added);
                //
                let element = event.added.element;
                let draggedHour = element.hour;
                let draggedHandyman = element.handyman_id;
                let oldHandymanId = element.handyman_id;

                // Get time in AM/PM from the target hour
                let droppedHour = moment(this.targetHour, 'HH').format('h:mm A');

                // Get the only minute from the time using moment
                let minute = moment(element.assigned_time, 'h:mm A').format('mm');

                // Add the minute into the hours
                let finalHour = moment(droppedHour, 'h:mm A').add(minute, 'm').format('h:mm A');

                // Update the assigned time
                element.assigned_time = finalHour;

                element.hour = this.targetHour;
                element.handyman_id = this.targetHandyman;

                // First check if target handyman and dragged handyman are the same then push the order
                if(draggedHandyman == this.targetHandyman) {
                    Object.keys(this.handymans).forEach((key) => {
                        if(this.handymans[key].id == draggedHandyman) {
                            this.handymans[key].tasks.push(element);
                        }
                    })
                }

                // Update the order in the database
                axios.post('/admin/orders/update-order', {
                        action: 'hours_or_handyman',
                        order_id: element.id,
                        old_handyman_id: oldHandymanId,
                        handyman_id: this.targetHandyman,
                        time: element.assigned_time,
                        hour: this.targetHour,
                        date: moment(this.selectedDate).format('YYYY-MM-DD'),
                        search_type: this.searchType, // today, tomorrow, last_month, this_month, next_month, this_week, next_week
                        target_date: this.targetDate
                    })
                        .then(response => {
                            self.$notification(response.data.status, response.data.message);
                            this.getTasks();
                        })
                        .catch(error => {
                            console.log(error);
                        });
            }

            //return false;
        },
        getRandomClass() {
            return this.taskItemClasses[Math.floor(Math.random() * this.taskItemClasses.length)];
        },
        scrollToRow(index) {
            // Get the reference to the target row
            // const targetRow = this.$refs['row-' + index];
            // if (targetRow) {
            //     // Scroll to the target row's offset top
            //     this.$refs.tableContainer.scrollTop = targetRow[0].offsetTop;
            // }

            // Ensure the row index is within the bounds of the table
            if (index >= 0 && index < this.orderTimes.length) {
                // Get the reference to the row element
                const rowElement = this.$refs.tableRow[index];
                // Scroll the row into view
                if (rowElement) {
                    rowElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        },
        formattedDate(date, format) {
            return moment(date).format(format);
        },
        handleScroll(event) {
            //console.log(window.scrollY);
            if (window.scrollY > 169) {
                this.fixedTaskHeadClass = 'fixed-task-head';
            }
            else {
                this.fixedTaskHeadClass = '';
            }
        },

        // Arranging the tasks based on the types
        changeTaskDisplayType() {
            if(this.searchType == 'day') {
                this.selectedDate = moment().format('DD MMM YYYY');
            }
            else if(this.searchType == 'tomorrow') {
                this.selectedDate = moment().add(1, 'days').format('DD MMM YYYY');
            }
            else if(this.searchType == 'this_week') {
                this.startOfWeek = moment().startOf('isoWeek').format('DD MMM YYYY');
                this.endOfWeek = moment().endOf('isoWeek').format('DD MMM YYYY');
                this.currentWeek = this.startOfWeek + ' - ' + this.endOfWeek;

                // Regenerate week days
                this.preparedWeekDays();
            }
            else if(this.searchType == 'next_week') {
                this.startOfWeek = moment().add(1, 'weeks').startOf('isoWeek').format('DD MMM YYYY');
                this.endOfWeek = moment().add(1, 'weeks').endOf('isoWeek').format('DD MMM YYYY');
                this.currentWeek = this.startOfWeek + ' - ' + this.endOfWeek;

                // Regenerate week days
                this.preparedWeekDays();
            }
            else if(this.searchType == 'this_month') {
                this.currentMonth = moment().format('MMM YYYY');
            }
            else if(this.searchType == 'last_month') {
                this.currentMonth = moment().subtract(1, 'months').format('MMM YYYY');
            }

            this.getTasks();
        },
        setTodayDateData() {
            this.selectedDate = moment().format('DD MMM YYYY');
            this.displayType = 'day';

            this.getTasks();
        },
        getNextData() {
            if (this.daysOptions.includes(this.searchType)) {
                this.searchType = 'custom_day';
            }
            else if (this.weekOptions.includes(this.searchType)) {
                this.searchType = 'custom_week';
            }
            else if (this.monthOptions.includes(this.searchType)) {
                this.searchType = 'custom_month';
            }
            // Check if display type is day then add 1 day
            if(this.daysOptions.includes(this.searchType)) {
                this.selectedDate = moment(this.selectedDate).add(1, 'days').format('DD MMM YYYY');
            }
            else if (this.weekOptions.includes(this.searchType)) {
                this.startOfWeek = moment(this.startOfWeek).add(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).add(1, "weeks");
                this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

                this.preparedWeekDays();
            }
            else if (this.monthOptions.includes(this.searchType)) {
                this.currentMonth = moment(this.currentMonth).add(1, "months");
                this.generateCalendar();
            }

            this.getTasks();
        },
        getPreviousData() {
            if (this.daysOptions.includes(this.searchType)) {
                this.searchType = 'custom_day';
            }
            else if (this.weekOptions.includes(this.searchType)) {
                this.searchType = 'custom_week';
            }
            else if (this.monthOptions.includes(this.searchType)) {
                this.searchType = 'custom_month';
            }

            // Check if display type is day then subtract 1 day
            if(this.daysOptions.includes(this.searchType)) {
                this.selectedDate = moment(this.selectedDate).subtract(1, 'days').format('DD MMM YYYY');
            }
            else if (this.weekOptions.includes(this.searchType)) {
                this.startOfWeek = moment(this.startOfWeek).subtract(1, "weeks");
                this.endOfWeek = moment(this.endOfWeek).subtract(1, "weeks");
                this.currentWeek = this.startOfWeek + " - " + this.endOfWeek;

                this.preparedWeekDays();
            }
            else if (this.monthOptions.includes(this.searchType)) {
                this.currentMonth = moment(this.currentMonth).subtract(1, "months");
                this.generateCalendar();
            }

            this.getTasks();
        },
        generateCalendar() {
            const currentDate = this.currentMonth;
            const year = currentDate.year();
            const month = currentDate.month();
            const firstDayOfMonth = moment([year, month, 1]).day(); // Day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
            const daysInMonth = currentDate.daysInMonth();

            const prevMonthDays = (firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1); // Adjusting for Monday as the first day of the week
            //const prevMonthDays = firstDayOfMonth === 0 ? 6 : firstDayOfMonth;
            const totalDays = prevMonthDays + daysInMonth;

            const calendar = [];
            let dayCounter = 1;

            for (let i = 0; i < 6; i++) {
                const week = [];
                for (let j = 0; j < 7; j++) {
                    if (i === 0 && j < prevMonthDays) {
                        week.push({ day: "", date: "" });
                    } else if (dayCounter <= daysInMonth) {
                        // Create a moment object for the current day
                        const dayDate = moment([year, month, dayCounter]);
                        week.push({
                            day: dayCounter,
                            date: dayDate.format('YYYY-MM-DD') // Format the date as 'YYYY-MM-DD'
                        });
                        dayCounter++;
                    } else {
                        week.push({ day: "", date: "" });
                    }
                }

                // Check if the week contains any non-empty day
                if (week.some((item) => item.day !== "")) {
                    calendar.push(week);
                }
            }

            this.calendar = calendar;
        },
        truncateString(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            }
            return str;
        },
        // Check if schedule is available for the given date
        isScheduleAvailable(date) {
            // First check if date is empty then return false
            if (!date) {
                return false;
            }

            const formattedDate = moment(date).format('YYYY-MM-DD');

            // Check if given date is less than current date then return false

            if (moment(formattedDate).isBefore(moment().format('YYYY-MM-DD'))) {
                return false;
            }
            // Use `Object.values()` to iterate over values of the `schedules` object
            // and `Array.prototype.some()` to check for at least one match.
            return Object.values(this.schedules).some(handymanSchedules =>
                handymanSchedules.some(schedule => schedule.schedule_date === formattedDate)
            );
        },
        exportToCSV() {
            // Define CSV headers
            const headers = ['Handyman Name','Customer Name', 'Customer Email', 'Customer Phone', 'Contact Person', 'Full Address', 'Postal Code', 'Service Name', 'Service Date', 'Service Time', 'Service Duration(in hrs)', 'Order Number'];
            // Create CSV content
            let csv = headers.join(',') + '\n';
            
            this.taskLists.forEach(task => {
                csv += `"${task.order_handymans.map(handyman => handyman?.handyman?.name).join(', ')}","${task?.customer_full_name}","${task?.customer_email}","${task?.customer_phone_number}","${task?.acp_full_name}","${task?.full_address}","${task?.postal_code}","${task?.order_items.map(item => item?.service?.name).join(', ')}","${this.dataTimeFormat(task?.assigned_at, 'DD/MM/YYYY')}","${task?.assigned_time}","${task?.assigned_order_duration}","${task?.order_number}"\n`;
            });
            
            // Create and trigger download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'tasks.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    watch: {
        selectedDate() {
            //this.getTasks();
        },
        displayType() {
            this.preparedWeekDays();
            this.changeTaskDisplayType();
        },
        searchType() {
            this.changeTaskDisplayType();
        },
        searchTerm() {
            this.getTasks();
        }
    }

};
</script>
<style scoped>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.order-list-group-item {
    cursor: move;
}
</style>
